import { useQuery } from '@tanstack/react-query';

import { fetchPrivateEventHistory } from '../../api/private-event-history';

import { privateEventHistoryKey } from './use-update-private-event';

const STALE_30S = 30_000;

export function usePrivateEventHistory(id: string) {
  return useQuery({
    queryKey: privateEventHistoryKey(id),
    queryFn: () => fetchPrivateEventHistory(id),
    enabled: id.length > 0,
    staleTime: STALE_30S,
    retry: false,
  });
}
